// Auto-generated skeleton for Report

import { ReportSubType } from './ReportSubType'
import { DocumentContainer } from './DocumentContainer'
import { User } from '@/stores/skeletons/User.ts'

export const Report: Api.Report = {
	id: 0,
	uuid: '',
	author_user_id: 0,
	assigned_team_id: 0,
	description: null,
	location: null,
	callback_phonenumber_id: 0,
	callback_number: null,
	is_internal: false,
	is_done: false,
	building_id: 0,
	unit_id: 0,
	report_status_id: 0,
	report_sub_type_id: 0,
	created: null,
	updated: null,
	synced: null,
	author_user: User,
	report_status: ReportSubType,
	report_sub_type: ReportSubType,
	assigned_team: null,
	callback_phonenumber: null,
	building: null,
	unit: null,
	document_containers: [DocumentContainer],
	craftsman_tasks_count: 0,
	cis_count: 0,
	tasks_count: 0,
}
